import { useLenis } from "lenis/react";

const Header = () => {
  const lenis = useLenis();
  const go = (target) => lenis?.scrollTo(target, { offset: -72, duration: 1.4 });

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ivory/70 border-b border-white/40" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button onClick={() => go(0)} className="text-left" data-testid="header-logo">
          <span className="font-serif text-xl md:text-2xl tracking-tight text-charcoal">Marlene Alesna</span>
          <span className="hidden md:block text-[10px] tracking-[0.25em] uppercase text-stone2 mt-0.5">Oahu Buyer&rsquo;s Agent &middot; eXp Realty</span>
        </button>
        <button
          onClick={() => go("#priority-list")}
          className="group relative overflow-hidden border border-teal text-teal px-5 py-2.5 text-xs tracking-[0.2em] uppercase font-semibold transition-colors duration-500 hover:text-ivory"
          data-testid="header-join-cta"
        >
          <span className="absolute inset-0 bg-teal translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
          <span className="relative">Join the Buyer List</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
